import axios from "../axios";

const getTranslationsData = async () => {
  const response = await axios.get("/Languages");
  return response.data;
};

export { getTranslationsData };
